import { render, staticRenderFns } from "./CPKYC.vue?vue&type=template&id=5649abbc&scoped=true&"
import script from "./CPKYC.vue?vue&type=script&lang=ts&"
export * from "./CPKYC.vue?vue&type=script&lang=ts&"
import style0 from "./CPKYC.vue?vue&type=style&index=0&id=5649abbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649abbc",
  null
  
)

export default component.exports